import * as React from 'react'

import { observer } from 'mobx-react'

import StatusBadge from '~/client/src/shared/components/StatusBadge/StatusBadge'
import WorkflowTypeIcon from '~/client/src/shared/components/WorkflowTypeIcon/WorkflowTypeIcon'
import { INTERPUNCT } from '~/client/src/shared/utils/usefulStrings'

import { IWorkflowCardData } from './WorkflowCardData.store'
import { WORKFLOW_CARD_SHELL_CLASS } from './WorkflowCardPlaceholder'

interface IProps {
  card: IWorkflowCardData
  onOpen(): void
}

function WorkflowCard({ card, onOpen }: IProps) {
  return (
    <div
      className={`${WORKFLOW_CARD_SHELL_CLASS} tw:cursor-pointer tw:text-left`}
      onClick={onOpen}
    >
      {!!card.typeName && (
        <div className="tw:text-xs tw:uppercase tw:text-muted-foreground">
          {card.typeName}
        </div>
      )}
      <div className="tw:mt-1 tw:flex tw:items-start tw:gap-1">
        <WorkflowTypeIcon
          iconName={card.typeIconName}
          size="small"
          className="tw:shrink-0"
        />
        <span
          title={card.caption}
          className="tw:min-w-0 tw:flex-1 tw:font-semibold tw:break-words"
        >
          {card.caption}
        </span>
        <StatusBadge
          className="tw:!flex-none"
          status={card.status}
          workflowStepLevel={card.workflowStepLevel}
          isLate={card.isLate}
        />
      </div>
      {!!card.companyNames.length && (
        <div className="tw:mt-1.5 tw:flex tw:flex-wrap tw:items-center tw:gap-1 tw:font-semibold">
          {card.companyNames.map((companyName, index) => (
            <React.Fragment key={`${companyName}-${index}`}>
              {index > 0 && (
                <span className="tw:text-muted-foreground">{INTERPUNCT}</span>
              )}
              <span>{companyName}</span>
            </React.Fragment>
          ))}
        </div>
      )}
      {!!card.dateText && (
        <div className="tw:mt-1 tw:text-muted-foreground">{card.dateText}</div>
      )}
      {!!card.locations.length && (
        <div className="tw:mt-1.5 tw:flex tw:flex-wrap tw:gap-x-2 tw:gap-y-1">
          {card.locations.map((location, index) => (
            <span
              key={`${location.name}-${index}`}
              title={location.name}
              className="tw:inline-flex tw:items-center tw:gap-1"
              style={{ color: location.color }}
            >
              <span
                className="tw:size-1.5 tw:shrink-0 tw:rounded-full"
                style={{ backgroundColor: location.color }}
                aria-hidden="true"
              />
              {location.name}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default observer(WorkflowCard)
